import GeominesPage from './Page'

export default GeominesPage
